<template>
    <PutForeground type="Stock Transfer"/>
</template>

<script>
import PutForeground from '@/views/put/Foreground.vue';

export default {
    components:{
        PutForeground
    },
}
</script>